import { Component, EventEmitter, HostBinding, HostListener, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { interfaces } from '@leandredev/dcbm-common-lib';
import { BehaviorSubject, Observable } from 'rxjs';
import { filter, map, switchMap } from 'rxjs/operators';

import { ThemeService } from '../../../@fury/services/theme.service';
import { SidenavItem } from './sidenav-item/sidenav-item.interface';
import { SidenavService } from './sidenav.service';
import { SignInJwtService } from 'src/app/services/signIn-jwt/signIn-jwt.service';
import { SidenavNavigationData } from './sidenav.data';
import { IDcbmService } from '@leandredev/dcbm-common-lib/dist/interfaces';
import { ProfileService } from 'src/app/services/profile/profile.service';
import { DepartmentService } from 'src/app/services/department/department.service';

@Component({
  selector: 'fury-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss']
})
export class SidenavComponent implements OnInit {
  // #region Properties (6)
  @Output() openQuickPanel = new EventEmitter();

  @Input()
  @HostBinding('class.collapsed')
  public collapsed: boolean;
  @Input()
  @HostBinding('class.expanded')
  public expanded: boolean;

  items$: Observable<SidenavItem[]>;
  public profile: interfaces.IUserAdmin;
  sidenavUserVisible$ = this.themeService.config$.pipe(map((config) => config.sidenavUserVisible));

  public userServices: BehaviorSubject<IDcbmService[]> = new BehaviorSubject<IDcbmService[]>([]);

  constructor(
    private router: Router,
    private sidenavService: SidenavService,
    private themeService: ThemeService,
    protected signInService: SignInJwtService,
    private navigationData: SidenavNavigationData,
    private profileService: ProfileService,
    private departmentService: DepartmentService
  ) {}

  @HostListener('mouseenter')
  @HostListener('touchenter')
  public onMouseEnter(): void {
    this.sidenavService.setExpanded(true);
  }

  @HostListener('mouseleave')
  @HostListener('touchleave')
  public onMouseLeave(): void {
    this.sidenavService.setExpanded(false);
  }

  private count = 0;

  public ngOnInit() {
    this.count += 1;

    this.items$ = this.sidenavService.items$.pipe(map((items: SidenavItem[]) => this.sidenavService.sortRecursive(items, 'position')));

    this.profileService.profile
      .pipe(filter((x) => !!x))
      .pipe(
        switchMap((profile) => {
          this.profile = profile;

          if (this.profile.isSuperAdmin) {
            this.sidenavService.addAdminNavigationData();
          }

          if (this.profile.allowImport) {
            this.sidenavService.addImportNavigationData();
          }

          return this.departmentService.getDCBMServicebyIds(this.profile.service);
        }),
        map((services) => {
          return this.userServices.next(services);
        }),
        switchMap(() => {
          return this.profileService.getServiceResposabilityForUser().pipe(
            map((managedService) => {
              this.managedService = managedService;
            })
          );
        })
      )
      .subscribe();

    this.navigationData.openQuickPanel = () => {
      this.openQuickPanel.emit();
    };
  }

  public managedService: IDcbmService;

  public toggleCollapsed(): void {
    this.sidenavService.toggleCollapsed();
  }

  public disconnect(): void {
    this.router
      .navigate(['/login'])
      .then(() => {
        this.signInService.disconnect();
      })
      .catch((err) => {
        console.warn(err);
      });
  }
}
